import Game from '../../Game';
import BaseUISystem from './BaseUISystem';
import BoosterHUDHandler from './HUD/BoosterHUDHandler';
import ThreeStarShareHandler from './Menu/ThreeStarShareHandler';
import HelperFriendHUDHandler from './HUD/HelperFriendHUDHandler';
import { HelperFriendStatus } from '../../State/Level/HelperFriend/HelperFriendStatus';
import InfoMenuHandler from './Menu/InfoMenuHandler';
import { ShopPopup } from './Menu/ShopPopup/ShopPopup';
import NoCoinsMenuHandler from './NotImplemented/NoCoinsMenuHandler';
import StreakInfoPopup from '../../Prototype/UI/Level/StreakInfoPopup';
import { LevelPopup } from './Menu/LevelPopup/LevelPopup';
import { BuyBoosterPopup } from './Menu/LevelPopup/BuyBoosterPopup';
import { LevelCompletePopup } from './Menu/LevelPopup/LevelCompletePopup';
import DataConflictsMenuHandler from '@platform/System/UI/Menu/DataConflictsMenuHandler';
import ConfirmSignOutMenuHandler from 'System/UI/Menu/ConfirmSignOutMenuHandler';
import { Platform } from 'Utility/Platform';
import HardSharePopup from './Menu/LevelPopup/HardSharePopup';
import { LevelHud } from 'System/UI/HUD/LevelHud';
import { SettingsPopup } from '@platform/System/UI/Menu/SettingsPopup';
import { TNTModifierWarningHUD } from './HUD/Level/TNTModifierWarningHUD';
import { QuitLevelPopup } from './Menu/LevelPopup/QuitLevelPopup';
import GBCDisconnectedMenuHandler from './Menu/GBCDisconnectedMenuHandler';

export default class LevelUISystem extends BaseUISystem {
    public init(): void {
        const levelHud = new LevelHud({ system: this });

        this.handlers = [
            new BoosterHUDHandler(this),
            new SettingsPopup(this),
            new ThreeStarShareHandler(this),
            new HardSharePopup(this),
            new InfoMenuHandler(this),
            new NoCoinsMenuHandler(this),
            new ShopPopup(this),
            new StreakInfoPopup(this),
            new LevelPopup(this),
            new QuitLevelPopup(this),
            new LevelCompletePopup(this),
            new BuyBoosterPopup(this),
            levelHud,
            new DataConflictsMenuHandler(this),
            new ConfirmSignOutMenuHandler(this),
            new TNTModifierWarningHUD(this),
            new GBCDisconnectedMenuHandler(this),
            new DataConflictsMenuHandler(this),
        ];

        if (Game.store.getState().platform.IAPSupport) {
            //this.handlers.push(new ShopPopup(this));
        }

        // if (
        //     Game.config.platform !== Platform.ANDROID &&
        //     Game.config.platform !== Platform.IOS &&
        //     Game.store.getState().levelState.helperFriendStatus === HelperFriendStatus.ENABLED
        // ) {
        //     this.handlers.push(new HelperFriendHUDHandler(this));
        // }
    }
}
